import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RouteComponentProps, withRouter } from "react-router"
import { StaticBackdropWithTabs } from "../../../common/modal"
import LoadingSpinner from "../../../common/spinner/loading.component"
import {
    INVENTORY_STOCK_DOCUMENT_DEFINITION_TABS,
    InventoryStockDocumentDefinitionTab
} from "../../../common/types/inventory"
import {
    InventoryStockDocumentDefinitionAction,
    InventoryStockDocumentDefinitionSelector
} from "../../../state/inventory"
import {
    STOCK_DOCUMENT_DEFINITION_EDIT_TABS
} from "../../../utils/inventory/utils"
import { DescriptionTab, StatusTab, TemplateTab } from "./tabs"


export const EditTabs = withRouter((props: RouteComponentProps<null>) => {
    const [key, setKey] = useState<InventoryStockDocumentDefinitionTab>(INVENTORY_STOCK_DOCUMENT_DEFINITION_TABS.DESCRIPTION)
    const isLoading = useSelector(InventoryStockDocumentDefinitionSelector.isLoading)
    const listing = useSelector(InventoryStockDocumentDefinitionSelector.getListing)
    const queryParams = new URLSearchParams(props.location.search)
    const dispatch = useDispatch()

    useEffect(() => {
        const emailTemplateId = queryParams.get("emailTemplateId")
        if (emailTemplateId) {
            const item = listing.find((item) => item.emailTemplates.map(t => t.id).includes(emailTemplateId))
            if (item && item?.id) {
                dispatch(InventoryStockDocumentDefinitionAction.setFromListing(item.id))
                setKey(INVENTORY_STOCK_DOCUMENT_DEFINITION_TABS.TEMPLATE)
            }
        }

        const templateId = queryParams.get("templateId")
        if (templateId) {
            const item = listing.find((item) => item.documentTemplates.map(t => t.id).includes(templateId))
            if (item && item?.id) {
                dispatch(InventoryStockDocumentDefinitionAction.setFromListing(item.id))
                setKey(INVENTORY_STOCK_DOCUMENT_DEFINITION_TABS.TEMPLATE)
            }
        }
    },[])

    if (isLoading) {
        return <LoadingSpinner/>
    }

    const getTabContent = () => {
        switch (key) {
        case INVENTORY_STOCK_DOCUMENT_DEFINITION_TABS.DESCRIPTION:
            return <DescriptionTab/>
        case INVENTORY_STOCK_DOCUMENT_DEFINITION_TABS.STATUS:
            return <StatusTab/>
        case INVENTORY_STOCK_DOCUMENT_DEFINITION_TABS.TEMPLATE:
            return <TemplateTab/>
        default:
            return <></>
        }
    }

    return (
        <StaticBackdropWithTabs
            activeTab={key}
            onChangeCallback={(k) => setKey(k as InventoryStockDocumentDefinitionTab)}
            tabs={STOCK_DOCUMENT_DEFINITION_EDIT_TABS}>

            {getTabContent()}

        </StaticBackdropWithTabs>
    )
})



// WEBPACK FOOTER //
// ./src/inventory/sections/documentTypes/EditTabs.tsx